export class ContatoStatus {
  id: number;
  descricao: string;
  tipo: number;
}
